import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import React from 'react';
import { Grid, Icon, Typography } from 'web-library';
import { IconName } from 'web-library/stories/atom/Icon/Icon';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  icon: {
    color: theme.color.text.textTertiary,
    marginRight: theme.spacing(2),
  },
  fileSize: {
    color: theme.color.text.textTertiary,
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    justifySelf: 'start',
    marginRight: theme.spacing(2),
  },
  filename: {
    textOverflow: 'ellipsis',
    flexGrow: 2,
    color: theme.color.text.textSecondary,
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(24),
    },
    [theme.breakpoints.down('md')]: {
      width: theme.spacing(24),
    },
  },
}));

interface DocumentBadgeProps {
  documentName: string;
  className?: string;
  fileSize?: string;
}

const DocumentBadge = ({ documentName, className, fileSize }: DocumentBadgeProps) => {
  const { classes } = useStyles();

  return (
    (<Grid
      className={className}
      container
      direction="row"
      justify="flex-start"
      alignItems="center"
      wrap="nowrap"
    >
      {documentName ? (
        <>
          <Grid className={classes.iconContainer}>
            <Icon className={classes.icon} name={IconName.document} />
            <Typography className={classes.filename} noWrap>
              {documentName}
            </Typography>
          </Grid>
          {fileSize && <Grid className={classes.fileSize}>{fileSize}</Grid>}
        </>
      ) : (
        <>-</>
      )}
    </Grid>)
  );
};

export default DocumentBadge;
